import { Component, Input, OnInit } from '@angular/core';
import { GfTitleService } from '../../services/core.title.service';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash-es';
import { SiteConfigService } from '../../services/core.site-config.service';
import { WikiService } from '../../../widgets/wiki/services/wiki.service';
import { WikiHelperService } from '../../../widgets/wiki/services/wiki.helper';

@Component({
    selector: 'site-splash',
    template: require('./site-splash.component.html')
})
export class SiteSplashComponent implements OnInit {

    protected siteConfig;
    private hostName;
    private siteName;
    protected inputs = {};
    protected wikiHtml = '';

    constructor(
        private window: Window,
        private wikiService: WikiService,
        private wikiHelperService: WikiHelperService,
        public stateService: StateService,
        private siteConfigService: SiteConfigService,
        private titleService: GfTitleService,
    ) {
    }

    ngOnInit() {

        const pageName = 'FrontPage';

        // Get site config, providing sensible defaults if not available
        this.siteConfig = this.siteConfigService.getSiteConfig() || {
            hostName: 'localhost',
            siteName: 'GForge',
            useCustomSiteSplash: 'N'
        };
        
        this.hostName = _.get(this.siteConfig, 'hostName', 'localhost');
        this.siteName = _.get(this.siteConfig, 'siteName', this.hostName);

        if (this.siteConfig?.useCustomSiteSplash == 'Y') {
            const urlFn = () => '/';

            var params = {
                pageName: 'FrontPage',
                section: 'admin',
                refId: 0,
                rel:'options,version,content'
            };

            this.wikiService.info(params.pageName, params)
            .then((data) => {
                const wikiContent = _.get(data, 'rel.content.data', '');
                this.wikiHtml = this.wikiHelperService.convertWikiWords(
                    wikiContent,
                    urlFn
                );
            });
        }

        this.titleService.setTitle(this.siteName);
    }

    gotoPage(pageName) {
        this.stateService.go('home', { sitepage: pageName });
    }
}